<div class="about-page">
  <div class="row">
    <div class="col-12 about-page-banner">
      <video autoplay muted loop playsinline>
        <source src="./../../assets/images/about-us.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div class="container-xl">
        <div class="inner-banner">
          <h2 class="f-p" data-aos="fade-down" data-aos-duration="1000">
            {{ herosConfig.title }}
          </h2>
          <p class="f-m" data-aos="fade-down" data-aos-duration="1000">
            {{ herosConfig.description }}
          </p>
          <div>
            <!--<button
              type="button"
              class="primaryBtn text-uppercase"
              data-aos="fade-down"
              data-aos-duration="600"
              (click)="isChatEnabled = true">
              LET'S CHAT
            </button>-->
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="container-xl">
        <div
          class="lightBlue who-we-are"
          data-aos="fade-down"
          data-aos-duration="500">
          <div class="row">
            <div
              class="col-md-12 col-lg-6"
              data-aos="fade-right"
              data-aos-duration="800">
              <div class="cont">
                <h6 class="f-m">Who we are</h6>
                <h3 class="f-p">
                  Bridging Cutting-Edge Technology with Contact Center Expertise
                </h3>
                <p class="f-a">
                  With its advanced network, deep IP expertise, and a wealth of
                  next-generation services, iKunnect is your strategic partner
                  in leveraging technology for a competitive edge. We understand
                  that your enterprise demands secure, reliable, and seamless
                  Hosted Contact Center SIP connectivity, and iKunnect delivers
                  with the simplicity and quality of service you need to stay
                  ahead today and tomorrow.
                </p>
              </div>
            </div>
            <div
              class="col-md-12 col-lg-6 img-col"
              data-aos="fade-left"
              data-aos-duration="800">
              <img src="../../assets/images/who-we-are.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="container-xl">
        <div class="img-card-row">
          <div
            class="img-card-col"
            data-aos="fade-right"
            data-aos-duration="500">
            <div class="img-card-cont">
              <h4 class="f-p">Innovation</h4>
              <p class="f-a">
                At the forefront of innovation, iKunnect is heavily investing in
                enterprise capabilities and network improvements to support
                next-generation, IP-based services like VoIP. As an industry
                leader, we're committed to providing convergence-enabling
                technologies and hosted services that accelerate your transition
                to IP.
              </p>
              <figure>
                <img src="../../assets/images/innovation-icon.svg" alt="" />
              </figure>
            </div>
          </div>
          <div
            class="img-card-col"
            data-aos="fade-left"
            data-aos-duration="500">
            <div class="img-card-cont">
              <h4 class="f-p">US-based with Global Presence</h4>
              <p class="f-a">
                Based in , Texas, iKunnect has a global presence across North
                America, Europe, and Asia. No matter where you are, iKunnect
                ensures you're connected and ready to compete.
              </p>
              <figure>
                <img src="../../assets/images/globe-icon.svg" alt="" />
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="container-xl">
        <div class="powered-by">
          <div
            class="powered-by-col"
            data-aos="fade-down"
            data-aos-duration="500">
            <div class="cont">
              <span class="f-m">Powered by the best</span>
              <h6 class="f-p">Our Partners</h6>
              <p class="f-a">
                iKunnect works with industry-leading technologies to offer
                tailored services, coaching, and support to complement our
                software solutions, no matter where you are on your strategy
                journey.
              </p>
            </div>
          </div>
          <div class="powered-by-col">
            <div
              class="company-col"
              data-aos="fade-right"
              data-aos-duration="500">
              <figcaption>
                <img
                  src="../../assets/images/amazon-webservices-logo.svg"
                  alt="" />
              </figcaption>
              <p class="f-a">
                Cloud computing is poised to be a significant player in the tech
                industry now and in the foreseeable future. In its ultimate
                form, it will provide the means for IT to be delivered to
                consumers as a service. The number of products and services
                offerings in the cloud computing space continues to grow and
                underscores the fact that it is where things are heading.
              </p>
            </div>
            <div
              class="company-col"
              data-aos="fade-left"
              data-aos-duration="500">
              <figcaption>
                <img src="../../assets/images/microsoft-logo.svg" alt="" />
              </figcaption>
              <p class="f-a">
                Microsoft's .Net solutions provide iKunnect with robust
                interfaces for its management interface as well as its Web
                Agent.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-contact-us class="spa0 col-12" />
    <app-explore-resources class="spa0 col-12"></app-explore-resources>
    <app-book-consultation [title]="title" class="spa0 col-12" />
  </div>
  <app-lets-chat *ngIf="isChatEnabled"></app-lets-chat>
</div>
